import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { MeioDePagamento } from 'src/app/models/meio-de-pagamento';
import { CarregandoService } from 'src/app/services/carregando.service';
import { MeiosDePagamentoService } from 'src/app/services/meios-de-pagamento.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';

@Component({
  selector: 'app-meios-de-pagamento-modal',
  templateUrl: './meios-de-pagamento-modal.component.html',
  styleUrls: ['./meios-de-pagamento-modal.component.scss']
})
export class MeiosDePagamentoModalComponent implements OnInit {

  meios: MeioDePagamento[] = [];

  campoOrdenacao = 'forma';
  ordenarDesc = false;
  statusSelecionado = 1;
  tiposDeStatus = [{ id: 0, nome: 'Bloqueado' }, { id: 1, nome: 'Ativo' }];
  preenchido = false;

  public config: PerfectScrollbarConfigInterface = {};

  constructor(
    private meiosDePagamentoService: MeiosDePagamentoService,
    public utilitarioService: UtilitarioService,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    public dialogRef: MatDialogRef<MeiosDePagamentoModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.buscarMeiosDePagamento();
  }

  ordena(campo) {

    if (campo) {

      this.campoOrdenacao = campo;
      this.ordenarDesc = !this.ordenarDesc;

      this.meios = this.meios.sort((a, b) => {
        const isAsc = !this.ordenarDesc;
        return this.compare(a[this.campoOrdenacao], b[this.campoOrdenacao], isAsc);
      });
    }

    return false;
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {

    if (typeof a === 'string') {
      a = a.toLowerCase();
    }

    if (typeof b === 'string') {
      b = b.toLowerCase();
    }

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  buscarMeiosDePagamento() {
    this.carregandoService.mostra('buscarMeiosDePagamento');

    this.meiosDePagamentoService.consultar(this.statusSelecionado, this.preenchido, this.campoOrdenacao, this.ordenarDesc ? 'desc' : 'asc').subscribe((data: any) => {

      this.meios = data;

      this.carregandoService.esconde('buscarMeiosDePagamento');

    }, (erro) => {
      this.carregandoService.esconde('buscarMeiosDePagamento');
      this.notificacaoService.erro(erro);
    });
  }

  salvar() {
    this.carregandoService.mostra('salvaMeiosDePagamento');

    this.meiosDePagamentoService.salvar(this.meios).subscribe(() => {
      this.notificacaoService.sucesso('Meios de pagamento salvos com sucesso!!!');
      this.carregandoService.esconde('salvaMeiosDePagamento');

    }, (erro) => {
      this.carregandoService.esconde('salvaMeiosDePagamento');
      this.notificacaoService.erro(erro);
    });
  }

  fechar() {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {

  }


}
